import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NotesModule } from '../notes.module';
import { NoteCompactComponent } from './note-compact.component';

// material
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NoteCompactContextComponent } from './note-compact-context/note-compact-context.component';

@NgModule({
  declarations: [
    NoteCompactComponent,
    NoteCompactContextComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NotesModule,

    // material
    MatButtonModule,
    MatTooltipModule,
    MatBadgeModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    NoteCompactComponent,
    NoteCompactContextComponent,
  ]
})
export class NoteCompactModule { }
